export default __webpack_public_path__ + "images/64e52df246f673aa5cc0abe7cfcf003a-calendar.svg";